export const isTouchSupported = () => {
  return !!(
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch)
  )
}
